export default defineNuxtPlugin(() => {
  return {
    provide: {
      xeovisionStorage: {
        getItem(item) {
          return localStorage.getItem(item);
        },
        setItem(item, value) {
          return localStorage.setItem(item, value);
        },
        remomveItem(item) {
          return localStorage.removeItem(item);
        },
      },
    },
  };
});
